"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACGradientCardGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var sampleSlice_1 = require("../redux/slice/sampleSlice");
var ACGradientCard_1 = require("./ACGradientCard");
var ACGradientCardGroup = function (props) {
    var _a, _b, _c;
    var context = props === null || props === void 0 ? void 0 : props.context;
    var className = (props === null || props === void 0 ? void 0 : props.className) || '';
    var activeCard = (_b = (_a = context === null || context === void 0 ? void 0 : context.state) === null || _a === void 0 ? void 0 : _a.dynamic[(context === null || context === void 0 ? void 0 : context.rootState) || '']) === null || _b === void 0 ? void 0 : _b[props.name];
    return ((0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-".concat((props === null || props === void 0 ? void 0 : props.cols) || 6, " gap-2 items-center ").concat(className), children: (_c = props === null || props === void 0 ? void 0 : props.options) === null || _c === void 0 ? void 0 : _c.map(function (cardSchema) {
            var isActive = activeCard === cardSchema.name;
            var onClick = cardSchema.clickable !== false
                ? function () {
                    context.dispatch((0, sampleSlice_1.setStateValue)({
                        path: "".concat(context.rootState, ".").concat(props.name),
                        value: cardSchema.name,
                    }));
                    if (cardSchema.handlers) {
                        (props === null || props === void 0 ? void 0 : props.executeEventHandlers) &&
                            (props === null || props === void 0 ? void 0 : props.executeEventHandlers(cardSchema.handlers, event));
                    }
                }
                : undefined;
            return ((0, jsx_runtime_1.jsx)(ACGradientCard_1.ACGradientCard, __assign({}, cardSchema, { active: isActive, onClick: onClick, context: context })));
        }) }));
};
exports.ACGradientCardGroup = ACGradientCardGroup;
